import { getTeacherLesson, getGrammar, getPractice } from "@/api/api";

export const namespaced = true;

export const state = {
  step: 0,
  teacher_lesson: null,
  grammar: null,
  practice: null,
};
export const mutations = {
  step: (state, payload) => {
    if (payload < 7 && payload >= 0) state.step = payload;
  },
  teacher_lesson: (state, payload) => {
    state.teacher_lesson = payload;
  },
  grammar: (state, payload) => {
    state.grammar = payload;
  },
  practice: (state, payload) => {
    state.practice = payload;
  },
};
export const getters = {
  step: (state) => state.step,
  teacher_lesson: (state) => state.teacher_lesson,
  practice: (state) => state.practice,
  grammar: (state) => state.grammar,
};
export const actions = {
  teacher_lesson: async (context, payload) => {
    const response = await getTeacherLesson(payload);
    context.commit("teacher_lesson", response.data);
  },
  practice: async (context, payload) => {
    const response = await getPractice(payload);
    context.commit("practice", response.data);
  },
  grammar: async (context, payload) => {
    const response = await getGrammar(payload);
    context.commit("grammar", response.data);
  },
};
